import Module from '../../utils/modules/Module';
import YoutubePlayer from "../../utils/youtube/YoutubePlayer";
import YoutubeManager from "../../utils/youtube/YoutubeManager";
import EventsManager from "../../utils/events/EventsManager";
import CustomEvents from "../../utils/events/CustomEvents";

export default class RemoteVideoModule extends Module {
  constructor(options) {
    super(options)
    this.DOMEl = this.options.element;

    this.youtubeContainers = document.querySelectorAll(".media-remote-video");

    YoutubeManager.start();

    if (!window.YTIsLoaded) {
      EventsManager.on(CustomEvents.youtube.API_LOADED, this.init)
    } else {
      this.init();
    }
  }

  init() {
    let hasFocused = false;

    this.youtubeContainers.forEach((el) => {
      const videoId = el.getAttribute("data-video"); //https://www.youtube.com/watch?v=VNc83vgEesc
      const playerId = videoId; //unique the player. can be whatever you want, but really need to be unique.

      const options = {
        autoplay: false, //player will launch in autoplay
        mute: false, //player will launch muted
        playsinline: true, //player is allowed to play video inline ( mobile support )
        loop: false, //player won't play video in loop
        tracking: true, //track video percent played
        controls: true // displays controls
      };

      const playerEl = el.querySelector(".player");

      if(playerEl) {
        // create player
        const videoPlayer = new YoutubePlayer(el, playerId, videoId, options);

        // buttons actions & overlay
        const btnPlayVideo = el.querySelector(".btn-play");
        const btnCloseVideo = el.querySelector(".btn-close");
        const container = el.querySelector(".media-video-container");
        const overlay = el.querySelector(".media-video-overlay");

        // open & play
        if(btnPlayVideo) {
          btnPlayVideo.addEventListener("click", () => {
            videoPlayer.play();

            if(btnCloseVideo) {
              btnCloseVideo.focus();
              btnCloseVideo.setAttribute('tabindex', '0');
            }

            if(overlay) {
              overlay.setAttribute('tabindex', '0');
            }

            container.removeAttribute('hidden');

            this.hideThenFix(el);
            hasFocused = false;
          })
        }

        // close & stop
        if(btnCloseVideo) {
          btnCloseVideo.addEventListener("click", () => {
            videoPlayer.stop();
            btnCloseVideo.setAttribute('tabindex', '-1');

            if(overlay) {
              overlay.setAttribute('tabindex', '-1');
            }

            container.setAttribute('hidden', 'true');
            btnPlayVideo.focus();

            this.resestFix(el);
          })
        }

        // keyboard actions
        if(overlay) {
          overlay.addEventListener('focusout', function () {
            if (!hasFocused) {
              btnCloseVideo.focus();
              hasFocused = true;
            }
          })
        }
      }
    });
  }


  // FIX if in a slider
  // ------------------------------------------------------

  hideThenFix(el) {
    if (el.closest('.tximg-video')) {
      if (el.closest('.splide-tximg.is-active')) {
        // see class in text-image.scss:360
        el.closest('.tximg-slider').classList.add('prep-modal');
      }
    }
  }

  resestFix(el) {
    if (el.closest('.tximg-video')) {
      if (el.closest('.splide-tximg.is-active')) {
        // see class in text-image.scss:360
        el.closest('.tximg-slider').classList.remove('prep-modal');
      }
    }
  }

}
